import script from "./employee-overview-search.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-overview-search.vue?vue&type=script&setup=true&lang=js"

import "./employee-overview-search.vue?vue&type=style&index=0&id=0b5ac5da&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b5ac5da"]])

export default __exports__